import { gql } from '@apollo/client'

export const COMPANY_LIST_QUERY = gql`
  query companyList($filter: JSON, $options: JSON) {
    companyList(filter: $filter, options: $options) {
      _id
      name
      domain
      status
      tags
      contactCount
      address {
        _id
        fullAddress
        city
        state
        country
      }
      contacts {
        _id
        profile {
          _id
          name
          email
        }
        phone
        type
        status
      }
    }
    companyListMeta(filter: $filter) {
      count
    }
  }
`
